import { composeIO } from 'react-compose-io'
import { dadosTipoLancamentoIO } from './DadosTipoLancamento.IO'
import DadosTipoLancamentoView from './DadosTipoLancamento.View'

export const DadosTipoLancamento = composeIO(DadosTipoLancamentoView, dadosTipoLancamentoIO)
